import React from "react";
import { Tree } from 'primereact/tree';
import Langs from "../../../app/lang/langs";
import styles from '../VcompCompnents.module.css';
import TabNavigationButtons from "./TabNavigationButtons";

/**
 * PublicFormTab - Renders the public aptitudes selection tree (case 1).
 * Users select aptitudes from a checkbox tree to add to the project form.
 */
export default function PublicFormTab({
    isMobile,
    mode,
    nodes,
    selectedKeys,
    onSelectionChange,
    nodeTemplatePublic,
    onPrevious,
    onNext,
}) {
    return (
        <div className={styles.tabFadeIn}>
            <div
                className={styles.modalTabCard}
                style={isMobile === 2 ? { height: 'calc(100vh - 150px)', display: 'flex', flexDirection: 'column' } : {}}
            >
                <div style={{ flex: 1, overflowY: 'auto' }}>
                    <div style={{ height: "calc(100vh - 250px)" }}>
                        <label className={styles.tabLabel}>
                            <Langs str="ADD_PUBLIC_APTITUDES" />
                        </label>
                        <Tree
                            value={nodes}
                            selectionMode="checkbox"
                            selectionKeys={selectedKeys}
                            filter={true}
                            nodeTemplate={nodeTemplatePublic}
                            filterPlaceholder="Search..."
                            onSelectionChange={(e) => onSelectionChange(e.value)}
                            className="w-full md:w-30rem custom-tree border-0"
                        />
                    </div>
                </div>
                {isMobile === 2 && (
                    <TabNavigationButtons
                        isMobile={isMobile}
                        mode={mode}
                        onPrevious={mode !== "edit" ? onPrevious : null}
                        onNext={onNext}
                        nextLabel={mode === "edit" ? <Langs str="SAVE" /> : <Langs str="Next" />}
                    />
                )}
            </div>
            {isMobile !== 2 && (
                <TabNavigationButtons
                    isMobile={isMobile}
                    mode={mode}
                    onPrevious={mode !== "edit" ? onPrevious : null}
                    onNext={onNext}
                    nextLabel={mode === "edit" ? <Langs str="SAVE" /> : <Langs str="Next" />}
                />
            )}
        </div>
    );
}
